module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mysection"
  }, [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择需要的公司"
    },
    model: {
      value: (_vm.filters.company_code),
      callback: function($$v) {
        _vm.$set(_vm.filters, "company_code", $$v)
      },
      expression: "filters.company_code"
    }
  }, _vm._l((_vm.tgs_options), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.code),
        callback: function($$v) {
          _vm.$set(item, "code", $$v)
        },
        expression: "item.code"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入话术名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getLists
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.datalist), function(item) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.listLoading),
        expression: "listLoading"
      }]
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "div-cards"
    }, [_c('div', [_c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-edit",
        "circle": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleEdit(item)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "el-icon-delete",
        "circle": "",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleDel(item)
        }
      }
    })], 1), _vm._v(" "), _c('el-divider', {
      staticClass: "var-text",
      attrs: {
        "content-position": "right"
      }
    }, [_vm._v(_vm._s(item.provider_name))]), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "text item"
    }, [_vm._v(_vm._s(item.name))]) : _c('div', {
      staticClass: "text items"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "itemmin"
    }, [_vm._v("\n\t\t\t\t  SID:" + _vm._s(item.script_id)), _c('br'), _vm._v("\n\t\t\t\t  IID:" + _vm._s(item.instance_id) + "\n\t\t\t\t")]), _vm._v(" "), _vm._l((item.variables), function(ins, index) {
      return _c('div', {
        staticClass: "var-text"
      }, [_vm._v(" \n\t\t\t\t\t变量" + _vm._s(index + 1) + ":" + _vm._s(ins.kn) + " = "), _c('font', {
        staticStyle: {
          "font-weight": "bold",
          "color": "#1b79dc",
          "text-decoration": "underline"
        }
      }, [_vm._v(_vm._s(ins.val))])], 1)
    }), _vm._v(" "), _vm._l((item.call_nums), function(ins, index) {
      return _c('div', {
        staticClass: "var-text"
      }, [_vm._v(" \n\t\t\t\t\t主叫" + _vm._s(index + 1) + ":"), _c('font', {
        staticStyle: {
          "font-weight": "bold",
          "color": "#a16408",
          "text-decoration": "underline"
        }
      }, [_vm._v(_vm._s(ins.nm))]), _vm._v("\n\t\t\t\t\t前缀:" + _vm._s(ins.qz) + "\n\t\t\t\t")], 1)
    })], 2)])], 1)
  }), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-drawer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.editViewLoading),
      expression: "editViewLoading"
    }],
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "before-close": _vm.clickClose,
      "size": "60%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1024"
    }
  }, [_c('div', {
    staticClass: "to-right"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-main', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.editformtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "公司"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.editForm.company_name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "选择脚本",
      "prop": "script_id"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "请输入/请选择"
    },
    on: {
      "change": _vm.selectIntances
    },
    model: {
      value: (_vm.editForm.script_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "script_id", $$v)
      },
      expression: "editForm.script_id"
    }
  }, _vm._l((_vm.scriptDatas), function(item) {
    return _c('el-option', {
      key: item.script_id,
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.script_id),
        callback: function($$v) {
          _vm.$set(item, "script_id", $$v)
        },
        expression: "item.script_id"
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "变量信息"
    }
  }, [_c('el-table', {
    attrs: {
      "stripe": "",
      "data": _vm.loabvarstr,
      "highlight-current-row": "",
      "row-style": "var-text"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editVars(scope.row)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kn",
      "label": "变量名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "val",
      "label": "值"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rk",
      "label": "描述"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "before-close": _vm.clickClose,
      "size": "60%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1024"
    }
  }, [_c('div', {
    staticClass: "to-right"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSaveSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "padding": "50px"
    }
  }, [_c('el-divider', [_c('font', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#071a2c"
    }
  }, [_vm._v("编辑数据")])], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "公司"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.editForm.company_name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.editForm.status),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "status", $$v)
      },
      expression: "editForm.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "有效",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无效",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "变量信息"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.addVars()
      }
    }
  }), _vm._v(" "), _c('el-table', {
    attrs: {
      "stripe": "",
      "data": _vm.loabvarstr,
      "highlight-current-row": "",
      "row-style": "var-text",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-edit",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editVars(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeVars(scope.row.kn)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kn",
      "label": "变量名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "val",
      "label": "值"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rk",
      "label": "描述"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "主叫号码"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "circle": "",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.addCallNums()
      }
    }
  }), _vm._v(" "), _c('el-table', {
    attrs: {
      "stripe": "",
      "data": _vm.loaNumberStr,
      "highlight-current-row": "",
      "row-style": "var-text"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeNums(scope.row.nm)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nm",
      "label": "主叫号码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qz",
      "label": "被叫前缀"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.editViewLoading),
      expression: "editViewLoading"
    }],
    attrs: {
      "title": "编辑变量",
      "visible": _vm.addVarsShow,
      "before-close": _vm.clickClose,
      "size": "40%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.addVarsShow = $event
      }
    }
  }, [_c('el-form', {
    ref: "addVarForm",
    attrs: {
      "model": _vm.addVarForm,
      "label-width": "80px"
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1024"
    }
  }, [_c('div', [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addVarsShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSaveVars.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-main', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.editformtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "变量名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addVarForm.kn),
      callback: function($$v) {
        _vm.$set(_vm.addVarForm, "kn", $$v)
      },
      expression: "addVarForm.kn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变量值"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addVarForm.val),
      callback: function($$v) {
        _vm.$set(_vm.addVarForm, "val", $$v)
      },
      expression: "addVarForm.val"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变量描述"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addVarForm.rk),
      callback: function($$v) {
        _vm.$set(_vm.addVarForm, "rk", $$v)
      },
      expression: "addVarForm.rk"
    }
  })], 1)], 1)])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "编辑号码",
      "visible": _vm.addNumberShow,
      "before-close": _vm.clickClose,
      "size": "40%",
      "with-header": false,
      "direction": "rtl"
    },
    on: {
      "update:visible": function($event) {
        _vm.addNumberShow = $event
      }
    }
  }, [_c('el-form', {
    ref: "addVarForm",
    attrs: {
      "model": _vm.addVarForm,
      "label-width": "80px"
    }
  }, [_c('el-container', {
    staticStyle: {
      "min-height": "100vh"
    }
  }, [_c('el-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1024"
    }
  }, [_c('div', {
    staticClass: "to-right"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addNumberShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSaveNums.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-main', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.editformtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "主叫号码"
    }
  }, [_c('el-select', {
    staticClass: "h-m-select",
    attrs: {
      "filterable": "",
      "placeholder": "输入主叫号码"
    },
    on: {
      "change": _vm.selectNumbers
    },
    model: {
      value: (_vm.addNumbForm.callNum),
      callback: function($$v) {
        _vm.$set(_vm.addNumbForm, "callNum", $$v)
      },
      expression: "addNumbForm.callNum"
    }
  }, _vm._l((_vm.callNumberList), function(item) {
    return _c('el-option', {
      key: item.call_num,
      attrs: {
        "label": item.call_num
      },
      model: {
        value: (item.call_num),
        callback: function($$v) {
          _vm.$set(item, "call_num", $$v)
        },
        expression: "item.call_num"
      }
    })
  }), 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d67d751c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/callsys/useCallScript.vue
// module id = 662
// module chunks = 1